<template>
  <el-table :data="tableData">
    <el-table-column prop="label" label="番号" width="60" />
    <el-table-column prop="value" :label="columnLabel" />
  </el-table>
</template>

<script>

export default {
  props: {
      first: {
          type: String,
          required: true
      },
      second: {
          type: String,
          required: true
      },
      setting: {
          type: Object,
          required: false,
      },
  },
  data () {
    return {
      maxStatuses: 20,
      maxMessages: 10,
    }
  },
  computed: {
    // props の別名（読みやすさ用）
    firstLevel () { return this.first },
    secondLevel () { return this.second },

    // 行数上限とカラム名
    rowLimit () {
      return this.secondLevel === 'StatusList' ? this.maxStatuses : this.maxMessages
    },
    columnLabel () {
      return this.secondLevel === 'StatusList' ? '定型ステータス名' : 'メッセージ'
    },

    // テーブル表示用データ
    tableData () {
      const top = this.setting[this.firstLevel] || {}
      const list = top[this.secondLevel] || []
      const sliced = Array.isArray(list) ? list.slice(0, this.rowLimit) : []
      return sliced.map((name, idx) => ({
        label: idx + 1,
        value: name,
      }))
    },
  },
}
</script>
